import React from 'react';

import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { NavLinkButton, Col, Grid, Row, Text } from '@shared/components/bootstrap';
import { Timestamp } from '@shared/components/helpers';

import { zendeskTicketURL } from '@admin/config/zendesk';
import { ZendeskTicketAssociationFragment } from '@admin/schema';

export const TicketAttributes: React.FC<{
  ticketAssociation: ZendeskTicketAssociationFragment;
}> = ({ ticketAssociation }) => {
  const { zdTicketID, createdAt, creator } = ticketAssociation;

  return (
    <Grid fluid>
      <Row>
        <Col md={1}>
          <Text alignment="left" tag="p">
            ID# {zdTicketID}
          </Text>
        </Col>
        <Col md={4}>
          <Text tag="p">
            Created: <Timestamp value={createdAt} format={Timestamp.Format.DateTime} />
          </Text>
        </Col>
        <Col md={4}>
          <Text tag="p">Created By: {creator?.name}</Text>
        </Col>
        <Col md={3}>
          <NavLinkButton kind="primary" target="_blank" to={zendeskTicketURL({ id: zdTicketID })}>
            View on Zendesk <FontAwesomeIcon icon={faExternalLinkAlt} />
          </NavLinkButton>
        </Col>
      </Row>
    </Grid>
  );
};
